import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { useEntitiesContext } from 'entities/EntitiesExport'
import {
  ReferralsViewProvider,
  useReferralsViewContext,
} from 'pages/settings/pages/referrals/context/referralsViewContext'

const ReferralsPageLayoutDefaultContent = () => {
  const store = useReferralsViewContext()
  const { usersStore } = useEntitiesContext()

  useEffect(() => {
    if (usersStore.user?.hasFirstPromoterRef) store.loadReferralsViewInitialData()
  }, [])

  return <Outlet />
}

export const ReferralsPageLayout = observer(() => {
  return (
    <ReferralsViewProvider>
      <ReferralsPageLayoutDefaultContent />
    </ReferralsViewProvider>
  )
})
